module.exports = __webpack_public_path__ + "img/billion_Acts.95f014d1.png";